import { FormattedMessage } from 'react-intl';
import sanitizeHtml from 'sanitize-html';

const escapeHtml = (dirtyHtml: string): string => {
  return sanitizeHtml(dirtyHtml, {
    allowedTags: ['br', 'strong', 'em', 'code'],
  });
};

type FormattedHtmlMessageProps = {
  id: string;
  values?: Record<string, string | number | null>;
};

const FormattedHtmlMessage = (props: FormattedHtmlMessageProps) => (
  <FormattedMessage {...props}>
    {chunks =>
      chunks.map((chunk, i) => (
        <span
          dangerouslySetInnerHTML={{ __html: escapeHtml(chunk as string) }}
          key={i}
        />
      ))
    }
  </FormattedMessage>
);

export default FormattedHtmlMessage;
